export const QUESTION_BANK = [
  "Dispute errors in my credit report for me.",
  "Apply to the credit card with the best perks based on my spending…",
  "Set up the best savings account for me and put $100 monthly into it…",
];
